/*
 * Map filters and query into a simple "Showing results for" bar
 * that appears above the results
 *
 * https://www.algolia.com/doc/api-reference/widgets/current-refinements/js/
 */
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { containers } from "./selectors"

/*
 * Item template. We're only returning the value in an inline element
 */
const renderListItem = item => `
      ${item.refinements
    .map(refinement => `<strong class="antialiased text-gray-600 uppercase font-bold">${refinement.value}</strong>`)
    .join(' + ')}
`;

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
    const { items } = renderOptions;
    /*
     * Adjust the starting label depending on if we do have
     * any matched results. This replaces the need for the
     * stats widget entirely rather than doing a complex hide/show
     * of a series of similar elements
     */
    const helper = renderOptions.instantSearchInstance.helper ?? null;
    let hits = 0;
    if(helper) {
        hits = helper.lastResults.nbHits
    }
    const label = hits > 0 ? `<span class="text-gray-400">Showing results for:</span>` : ``;

    /*
     * Adds the markup to the DOM based on the widget settings below
     * Applies the label set above and iterates over each refinement and
     * query adding a "+" between each
     */
    document.querySelector('[data-generators-current-refinements]').innerHTML = `${label}
      ${items.map(renderListItem).join('+')}
  `;
};

// Create the custom widget
const customRefinement = connectCurrentRefinements(renderCurrentRefinements)
export const generatorsCurrentRefinements = customRefinement({
    container: containers.currentRefinements,
    excludedAttributes: [], // by default, algolia excludes 'query'. We're including that
    cssClasses: {
        root: 'text-gray-400 label'
    }
})